<!-- Раскрытый ФАКТ объединяет готовую формулу, пробег и компактный состав расходов. -->
<template>
  <section class="fact-panel">
    <div v-if="isLoading" class="fact-panel__empty">Загружаем ФАКТ…</div>

    <template v-else-if="canViewExpenses">
      <PlanCalculationFactFormula
        :order-price="orderPrice"
        :expenses-total="total"
        :expense-count-label="expenseCountLabel"
        :profit="profit"
        :mileage="mileage"
        :overridden="mileageOverridden"
        :profit-per-km="profitPerKm"
        :planned-profit-per-km="plannedProfitPerKm"
      />

      <PlanCalculationFactMileageEditor
        :mileage="mileage"
        :telemetry-mileage="telemetryMileage"
        :planned-mileage="plannedMileage"
        :overridden="mileageOverridden"
        :updated-by="mileageUpdatedBy"
        :updated-at="mileageUpdatedAt"
        :telemetry-updated-at="telemetryUpdatedAt"
        :refresh-pending="mileageRefreshPending"
        :is-submitting="isMileageSubmitting"
        :editable="canEditMileage"
        @save="$emit('save-mileage', $event)"
        @reset="$emit('reset-mileage')"
        @refresh="$emit('refresh-mileage')"
      />

      <PlanCalculationFactExpensesOverview
        :categories="categories"
        :latest-expenses="latestExpenses"
        :expense-count="expenseCount"
        :expense-count-label="expenseCountLabel"
        @edit-expense="$emit('edit-expense', $event)"
        @open-expenses="$emit('open-expenses')"
      />
    </template>

    <div v-else class="fact-panel__empty">Нет доступа к расходам</div>
  </section>
</template>

<script>
import PlanCalculationFactExpensesOverview from "@/components/Order/PlanCalculation/FactExpensesOverview.vue";
import PlanCalculationFactFormula from "@/components/Order/PlanCalculation/FactFormula.vue";
import PlanCalculationFactMileageEditor from "@/components/Order/PlanCalculation/FactMileageEditor.vue";

export default {
  name: "OrderPlanCalculationFactPanel",

  components: {
    PlanCalculationFactExpensesOverview,
    PlanCalculationFactFormula,
    PlanCalculationFactMileageEditor,
  },

  props: {
    total: { type: [String, Number], default: 0 },
    orderPrice: { type: [String, Number], default: null },
    profit: { type: [String, Number], default: null },
    mileage: { type: [String, Number], default: null },
    telemetryMileage: { type: [String, Number], default: null },
    plannedMileage: { type: [String, Number], default: null },
    profitPerKm: { type: [String, Number], default: null },
    plannedProfitPerKm: { type: [String, Number], default: null },
    mileageOverridden: { type: Boolean, default: false },
    mileageUpdatedBy: { type: String, default: "" },
    mileageUpdatedAt: { type: String, default: "" },
    telemetryUpdatedAt: { type: String, default: "" },
    mileageRefreshPending: { type: Boolean, default: false },
    isMileageSubmitting: { type: Boolean, default: false },
    expenseCount: { type: Number, default: 0 },
    expenseCountLabel: { type: String, default: "0 записей" },
    categories: { type: Array, default: () => [] },
    latestExpenses: { type: Array, default: () => [] },
    isLoading: { type: Boolean, default: false },
    canViewExpenses: { type: Boolean, default: false },
    canEditMileage: { type: Boolean, default: false },
  },

  emits: [
    "edit-expense",
    "open-expenses",
    "save-mileage",
    "reset-mileage",
    "refresh-mileage",
  ],
};
</script>

<style scoped>
.fact-panel {
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 0;
}

.fact-panel__empty {
  padding: 24px 14px;
  border: 1px solid #ffedd5;
  border-radius: 10px;
  color: #5b6070;
  font-size: 13px;
  text-align: center;
}
</style>
